import { env } from '@/env'

/**
 * Operator kill-switch banner.
 *
 * Rendered above the two-pane split on every route when
 * `VITE_DEGRADED_MODE` is `true`. Purely informational — it never blocks
 * sign-in/out actions, so incident response can still drive the flow even
 * while backend dependencies are flapping.
 *
 * Returns `null` when the flag is off, so the component can be parked
 * unconditionally in `Page` without a per-call-site guard.
 */
export function DegradedBanner() {
  if (!env.VITE_DEGRADED_MODE) return null

  return (
    <div role="status" aria-live="polite" className="degraded-banner">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        width={16}
        height={16}
        aria-hidden="true"
        className="degraded-banner__icon"
      >
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
      <span>
        Spaceti is experiencing issues. Some workspaces may be unavailable.
      </span>
    </div>
  )
}
